{
	"Language 01": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "en",
					"en": "en",
					"en-GB": "en",
					"en-US": "en",
					"es": "en",
					"es-419": "en",
					"es-ES": "en",
					"he": "en",
					"it": "esso",
					"pl": "pl",
					"sw": "sw",
					"tl": "en",
					"vi": "en",
					"zh": "英文"
				},
				"value": "en"
			},
			"label": {
				"translations": {
					"ar": "إنجليزي",
					"en": "English",
					"en-GB": "English",
					"en-US": "English",
					"es": "Inglés",
					"es-419": "Inglés",
					"es-ES": "Inglés",
					"he": "אַנגְלִית",
					"it": "Inglese",
					"pl": "angielski",
					"sw": "Kiingereza",
					"tl": "Ingles",
					"vi": "Tiếng Anh",
					"zh": "英语"
				},
				"value": "English"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇺🇸/🇬🇧",
					"en": "🇺🇸/🇬🇧",
					"en-GB": "🇺🇸/🇬🇧",
					"en-US": "🇺🇸/🇬🇧",
					"es": "🇺🇸/🇬🇧",
					"es-419": "🇺🇸/🇬🇧",
					"es-ES": "🇺🇸/🇬🇧",
					"he": "🇺🇸/🇬🇧",
					"it": "🇺🇸/🇬🇧",
					"pl": "🇺🇸/🇬🇧",
					"sw": "🇺🇸/🇬🇧",
					"tl": "🇺🇸/🇬🇧",
					"vi": "🇺🇸/🇬🇧",
					"zh": "🇺🇸/🇬🇧"
				},
				"value": "🇺🇸/🇬🇧"
			}
		}
	},
	"Language 02": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "en-US",
					"en": "en-US",
					"en-GB": "en-US",
					"en-US": "en-US",
					"es": "en-US",
					"es-419": "en-US",
					"es-ES": "en-US",
					"he": "en-US",
					"it": "en-US",
					"pl": "en-US",
					"sw": "en-US",
					"tl": "en-US",
					"vi": "en-US",
					"zh": "美国英语"
				},
				"value": "en-US"
			},
			"default": {
				"translations": {
					"ar": "حقيقي",
					"en": "true",
					"en-GB": "true",
					"en-US": "true",
					"es": "verdadero",
					"es-419": "verdadero",
					"es-ES": "verdadero",
					"he": "נָכוֹן",
					"it": "VERO",
					"pl": "PRAWDA",
					"sw": "kweli",
					"tl": "totoo",
					"vi": "ĐÚNG VẬY",
					"zh": "真的"
				},
				"value": "true"
			},
			"label": {
				"translations": {
					"ar": "الإنجليزية (الولايات المتحدة)",
					"en": "English (United States)",
					"en-GB": "English (United States)",
					"en-US": "English (United States)",
					"es": "Inglés (Estados Unidos)",
					"es-419": "Inglés (Estados Unidos)",
					"es-ES": "Inglés (Estados Unidos)",
					"he": "אנגלית (ארצות הברית)",
					"it": "Inglese (Stati Uniti)",
					"pl": "Angielski (Stany Zjednoczone)",
					"sw": "Kiingereza (Marekani)",
					"tl": "Ingles (Estados Unidos)",
					"vi": "Tiếng Anh (Hoa Kỳ)",
					"zh": "英语（美国）"
				},
				"value": "English (United States)"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇺🇸",
					"en": "🇺🇸",
					"en-GB": "🇺🇸",
					"en-US": "🇺🇸",
					"es": "🇺🇸",
					"es-419": "🇺🇸",
					"es-ES": "🇺🇸",
					"he": "🇺🇸",
					"it": "🇺🇸",
					"pl": "🇺🇸",
					"sw": "🇺🇸",
					"tl": "🇺🇸",
					"vi": "🇺🇸",
					"zh": "🇺🇸"
				},
				"value": "🇺🇸"
			}
		}
	},
	"Language 03": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "en-GB",
					"en": "en-GB",
					"en-GB": "en-GB",
					"en-US": "en-GB",
					"es": "es-GB",
					"es-419": "es-GB",
					"es-ES": "es-GB",
					"he": "en-GB",
					"it": "en-GB",
					"pl": "en-GB",
					"sw": "en-GB",
					"tl": "en-GB",
					"vi": "en-GB",
					"zh": "英国"
				},
				"value": "en-GB"
			},
			"label": {
				"translations": {
					"ar": "إنجليزي",
					"en": "English",
					"en-GB": "English",
					"en-US": "English",
					"es": "Inglés",
					"es-419": "Inglés",
					"es-ES": "Inglés",
					"he": "אַנגְלִית",
					"it": "Inglese",
					"pl": "angielski",
					"sw": "Kiingereza",
					"tl": "Ingles",
					"vi": "Tiếng Anh",
					"zh": "英语"
				},
				"value": "English"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇬🇧",
					"en": "🇬🇧",
					"en-GB": "🇬🇧",
					"en-US": "🇬🇧",
					"es": "🇪🇸",
					"es-419": "🇪🇸",
					"es-ES": "🇪🇸",
					"he": "🇬🇧",
					"it": "🇬🇧",
					"pl": "🇬🇧",
					"sw": "🇬🇧",
					"tl": "🇬🇧",
					"vi": "🇬🇧",
					"zh": "🇬🇧"
				},
				"value": "🇬🇧"
			}
		}
	},
	"Language 04": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "es",
					"en": "es",
					"en-GB": "es",
					"en-US": "es",
					"es": "es",
					"es-419": "es",
					"es-ES": "es",
					"he": "es",
					"it": "es",
					"pl": "es",
					"sw": "es",
					"tl": "es",
					"vi": "es",
					"zh": "es"
				},
				"value": "es"
			},
			"label": {
				"translations": {
					"ar": "الأسبانية",
					"en": "Spanish",
					"en-GB": "Spanish",
					"en-US": "Spanish",
					"es": "Español",
					"es-419": "Español",
					"es-ES": "Español",
					"he": "סְפָרַדִית",
					"it": "spagnolo",
					"pl": "hiszpański",
					"sw": "Kihispania",
					"tl": "Espanyol",
					"vi": "tiếng Tây Ban Nha",
					"zh": "西班牙语"
				},
				"value": "Spanish"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇲🇽/🇪🇸",
					"en": "🇲🇽/🇪🇸",
					"en-GB": "🇲🇽/🇪🇸",
					"en-US": "🇲🇽/🇪🇸",
					"es": "🇲🇽/🇪🇸",
					"es-419": "🇲🇽/🇪🇸",
					"es-ES": "🇲🇽/🇪🇸",
					"he": "🇲🇽/🇪🇸",
					"it": "🇲🇽/🇪🇸",
					"pl": "🇲🇽/🇪🇸",
					"sw": "🇲🇽/🇪🇸",
					"tl": "🇲🇽/🇪🇸",
					"vi": "🇲🇽/🇪🇸",
					"zh": "🇲🇽/🇪🇸"
				},
				"value": "🇲🇽/🇪🇸"
			}
		}
	},
	"Language 05": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "es-ES",
					"en": "es-ES",
					"en-GB": "es-ES",
					"en-US": "es-ES",
					"es": "es-ES",
					"es-419": "es-ES",
					"es-ES": "es-ES",
					"he": "es-ES",
					"it": "es-ES",
					"pl": "es-ES",
					"sw": "es-ES",
					"tl": "es-ES",
					"vi": "es-ES",
					"zh": "es-ES"
				},
				"value": "es-ES"
			},
			"label": {
				"translations": {
					"ar": "الإسبانية",
					"en": "Español",
					"en-GB": "Español",
					"en-US": "Español",
					"es": "Español",
					"es-419": "Español",
					"es-ES": "Español",
					"he": "ספרדית",
					"it": "Spagnolo",
					"pl": "hiszpański",
					"sw": "Kihispania",
					"tl": "Espanyol",
					"vi": "Tiếng Tây Ban Nha",
					"zh": "西班牙语"
				},
				"value": "Español"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇪🇸",
					"en": "🇪🇸",
					"en-GB": "🇪🇸",
					"en-US": "🇪🇸",
					"es": "🇪🇸",
					"es-419": "🇪🇸",
					"es-ES": "🇪🇸",
					"he": "🇪🇸",
					"it": "🇪🇸",
					"pl": "🇪🇸",
					"sw": "🇪🇸",
					"tl": "🇪🇸",
					"vi": "🇪🇸",
					"zh": "🇪🇸"
				},
				"value": "🇪🇸"
			}
		}
	},
	"Language 06": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "es-419",
					"en": "es-419",
					"en-GB": "es-419",
					"en-US": "es-419",
					"es": "es-419",
					"es-419": "es-419",
					"es-ES": "es-419",
					"he": "es-419",
					"it": "es-419",
					"pl": "es-419",
					"sw": "es-419",
					"tl": "es-419",
					"vi": "es-419",
					"zh": "es-419"
				},
				"value": "es-419"
			},
			"label": {
				"translations": {
					"ar": "الإسبانية (أمريكا اللاتينية)",
					"en": "Spanish (Latin America)",
					"en-GB": "Spanish (Latin America)",
					"en-US": "Spanish (Latin America)",
					"es": "Español (América Latina)",
					"es-419": "Español (América Latina)",
					"es-ES": "Español (América Latina)",
					"he": "ספרדית (אמריקה הלטינית)",
					"it": "spagnolo (America Latina)",
					"pl": "hiszpański (Ameryka Łacińska)",
					"sw": "Kihispania (Amerika ya Kilatini)",
					"tl": "Espanyol (Latin America)",
					"vi": "Tiếng Tây Ban Nha (Mỹ Latinh)",
					"zh": "西班牙语（拉丁美洲）"
				},
				"value": "Spanish (Latin America)"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇲🇽",
					"en": "🇲🇽",
					"en-GB": "🇲🇽",
					"en-US": "🇲🇽",
					"es": "🇲🇽",
					"es-419": "🇲🇽",
					"es-ES": "🇲🇽",
					"he": "🇲🇽",
					"it": "🇲🇽",
					"pl": "🇲🇽",
					"sw": "🇲🇽",
					"tl": "🇲🇽",
					"vi": "🇲🇽",
					"zh": "🇲🇽"
				},
				"value": "🇲🇽"
			}
		}
	},
	"Language 07": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "zh",
					"en": "zh",
					"en-GB": "zh",
					"en-US": "zh",
					"es": "zh",
					"es-419": "zh",
					"es-ES": "zh",
					"he": "ז'",
					"it": "zh",
					"pl": "zh",
					"sw": "zh",
					"tl": "zh",
					"vi": "zh",
					"zh": "zh"
				},
				"value": "zh"
			},
			"label": {
				"translations": {
					"ar": "الصينية",
					"en": "Chinese",
					"en-GB": "Chinese",
					"en-US": "Chinese",
					"es": "Chino",
					"es-419": "Chino",
					"es-ES": "Chino",
					"he": "סִינִית",
					"it": "cinese",
					"pl": "chiński",
					"sw": "Kichina",
					"tl": "Tsino",
					"vi": "Trung Quốc",
					"zh": "中国人"
				},
				"value": "Chinese"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇨🇳",
					"en": "🇨🇳",
					"en-GB": "🇨🇳",
					"en-US": "🇨🇳",
					"es": "🇨🇳",
					"es-419": "🇨🇳",
					"es-ES": "🇨🇳",
					"he": "🇨🇳",
					"it": "🇨🇳",
					"pl": "🇨🇳",
					"sw": "🇨🇳",
					"tl": "🇨🇳",
					"vi": "🇨🇳",
					"zh": "🇨🇳"
				},
				"value": "🇨🇳"
			}
		}
	},
	"Language 08": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "جنوب غرب",
					"en": "sw",
					"en-GB": "sw",
					"en-US": "sw",
					"es": "sudoeste",
					"es-419": "sudoeste",
					"es-ES": "sudoeste",
					"he": "שד",
					"it": "sw",
					"pl": "południowy zachód",
					"sw": "sw",
					"tl": "sw",
					"vi": "sw",
					"zh": "sw"
				},
				"value": "sw"
			},
			"label": {
				"translations": {
					"ar": "السواحيلية",
					"en": "Swahili",
					"en-GB": "Swahili",
					"en-US": "Swahili",
					"es": "swahili",
					"es-419": "swahili",
					"es-ES": "swahili",
					"he": "סוואהילית",
					"it": "Swahili",
					"pl": "suahili",
					"sw": "Kiswahili",
					"tl": "Swahili",
					"vi": "Tiếng Swahili",
					"zh": "斯瓦希里语"
				},
				"value": "Swahili"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇰🇪/🇹🇿",
					"en": "🇰🇪/🇹🇿",
					"en-GB": "🇰🇪/🇹🇿",
					"en-US": "🇰🇪/🇹🇿",
					"es": "🇰🇪/🇹🇿",
					"es-419": "🇰🇪/🇹🇿",
					"es-ES": "🇰🇪/🇹🇿",
					"he": "🇰🇪/🇹🇿",
					"it": "🇰🇪/🇹🇿",
					"pl": "🇰🇪/🇹🇿",
					"sw": "🇰🇪/🇹🇿",
					"tl": "🇰🇪/🇹🇿",
					"vi": "🇰🇪/🇹🇿",
					"zh": "🇰🇪/🇹🇿"
				},
				"value": "🇰🇪/🇹🇿"
			}
		}
	},
	"Language 09": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "tl",
					"en": "tl",
					"en-GB": "tl",
					"en-US": "tl",
					"es": "tl",
					"es-419": "tl",
					"es-ES": "tl",
					"he": "טל",
					"it": "in breve",
					"pl": "tl",
					"sw": "tl",
					"tl": "tl",
					"vi": "tl",
					"zh": "tl"
				},
				"value": "tl"
			},
			"dir": {
				"translations": {
					"ar": "حرف",
					"en": "ltr",
					"en-GB": "ltr",
					"en-US": "ltr",
					"es": "ltr",
					"es-419": "ltr",
					"es-ES": "ltr",
					"he": "ליטר",
					"it": "litri",
					"pl": "ltr",
					"sw": "ltr",
					"tl": "litro",
					"vi": "thư",
					"zh": "升"
				},
				"value": "ltr"
			},
			"label": {
				"translations": {
					"ar": "التاغالوغية",
					"en": "Tagalog",
					"en-GB": "Tagalog",
					"en-US": "Tagalog",
					"es": "Tagalo",
					"es-419": "Tagalo",
					"es-ES": "Tagalo",
					"he": "טגלוג",
					"it": "Tagalog",
					"pl": "Tagalski",
					"sw": "Kitagalogi",
					"tl": "Tagalog",
					"vi": "Tiếng Tagalog",
					"zh": "他加禄语"
				},
				"value": "Tagalog"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇵🇭",
					"en": "🇵🇭",
					"en-GB": "🇵🇭",
					"en-US": "🇵🇭",
					"es": "🇵🇭",
					"es-419": "🇵🇭",
					"es-ES": "🇵🇭",
					"he": "🇵🇭",
					"it": "🇵🇭",
					"pl": "🇵🇭",
					"sw": "🇵🇭",
					"tl": "🇵🇭",
					"vi": "🇵🇭",
					"zh": "🇵🇭"
				},
				"value": "🇵🇭"
			}
		}
	},
	"Language 10": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "vi",
					"en": "vi",
					"en-GB": "vi",
					"en-US": "vi",
					"es": "vi",
					"es-419": "vi",
					"es-ES": "vi",
					"he": "וי",
					"it": "vi",
					"pl": "vi",
					"sw": "vi",
					"tl": "vi",
					"vi": "vi",
					"zh": "六"
				},
				"value": "vi"
			},
			"dir": {
				"translations": {
					"ar": "حرف",
					"en": "ltr",
					"en-GB": "ltr",
					"en-US": "ltr",
					"es": "ltr",
					"es-419": "ltr",
					"es-ES": "ltr",
					"he": "ליטר",
					"it": "litri",
					"pl": "ltr",
					"sw": "ltr",
					"tl": "litro",
					"vi": "thư",
					"zh": "升"
				},
				"value": "ltr"
			},
			"label": {
				"translations": {
					"ar": "الفيتناميين",
					"en": "Vietnamese",
					"en-GB": "Vietnamese",
					"en-US": "Vietnamese",
					"es": "vietnamita",
					"es-419": "vietnamita",
					"es-ES": "vietnamita",
					"he": "וייטנאמית",
					"it": "vietnamita",
					"pl": "wietnamski",
					"sw": "Kivietnam",
					"tl": "Vietnamese",
					"vi": "Tiếng Việt",
					"zh": "越南语"
				},
				"value": "Vietnamese"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇻🇳",
					"en": "🇻🇳",
					"en-GB": "🇻🇳",
					"en-US": "🇻🇳",
					"es": "🇻🇳",
					"es-419": "🇻🇳",
					"es-ES": "🇻🇳",
					"he": "🇻🇳",
					"it": "🇻🇳",
					"pl": "🇻🇳",
					"sw": "🇻🇳",
					"tl": "🇻🇳",
					"vi": "🇻🇳",
					"zh": "🇻🇳"
				},
				"value": "🇻🇳"
			}
		}
	},
	"Language 11": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "ar",
					"en": "ar",
					"en-GB": "ar",
					"en-US": "ar",
					"es": "Arkansas",
					"es-419": "Arkansas",
					"es-ES": "Arkansas",
					"he": "אר",
					"it": "esso",
					"pl": "ar",
					"sw": "ar",
					"tl": "ar",
					"vi": "ar",
					"zh": "ar"
				},
				"value": "ar"
			},
			"dir": {
				"translations": {
					"ar": "من اليمين إلى اليسار",
					"en": "rtl",
					"en-GB": "rtl",
					"en-US": "rtl",
					"es": "derecho",
					"es-419": "derecho",
					"es-ES": "derecho",
					"he": "rtl",
					"it": "rtl",
					"pl": "rtl",
					"sw": "rtl",
					"tl": "rtl",
					"vi": "rtl",
					"zh": "右翼"
				},
				"value": "rtl"
			},
			"label": {
				"translations": {
					"ar": "عربي",
					"en": "Arabic",
					"en-GB": "Arabic",
					"en-US": "Arabic",
					"es": "árabe",
					"es-419": "árabe",
					"es-ES": "árabe",
					"he": "עֲרָבִית",
					"it": "arabo",
					"pl": "arabski",
					"sw": "Kiarabu",
					"tl": "Arabe",
					"vi": "tiếng Ả Rập",
					"zh": "阿拉伯"
				},
				"value": "Arabic"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇸🇦",
					"en": "🇸🇦",
					"en-GB": "🇸🇦",
					"en-US": "🇸🇦",
					"es": "🇸🇦",
					"es-419": "🇸🇦",
					"es-ES": "🇸🇦",
					"he": "🇸🇦",
					"it": "🇸🇦",
					"pl": "🇸🇦",
					"sw": "🇸🇦",
					"tl": "🇸🇦",
					"vi": "🇸🇦",
					"zh": "🇸🇦"
				},
				"value": "🇸🇦"
			}
		}
	},
	"Language 12": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "هو",
					"en": "he",
					"en-GB": "he",
					"en-US": "he",
					"es": "él",
					"es-419": "él",
					"es-ES": "él",
					"he": "הוּא",
					"it": "Lui",
					"pl": "On",
					"sw": "yeye",
					"tl": "siya",
					"vi": "Anh ta",
					"zh": "他"
				},
				"value": "he"
			},
			"dir": {
				"translations": {
					"ar": "من اليمين إلى اليسار",
					"en": "rtl",
					"en-GB": "rtl",
					"en-US": "rtl",
					"es": "derecho",
					"es-419": "derecho",
					"es-ES": "derecho",
					"he": "rtl",
					"it": "rtl",
					"pl": "rtl",
					"sw": "rtl",
					"tl": "rtl",
					"vi": "rtl",
					"zh": "右翼"
				},
				"value": "rtl"
			},
			"label": {
				"translations": {
					"ar": "العبرية",
					"en": "Hebrew",
					"en-GB": "Hebrew",
					"en-US": "Hebrew",
					"es": "hebreo",
					"es-419": "hebreo",
					"es-ES": "hebreo",
					"he": "עִברִית",
					"it": "ebraico",
					"pl": "hebrajski",
					"sw": "Kiebrania",
					"tl": "Hebreo",
					"vi": "tiếng Do Thái",
					"zh": "希伯来语"
				},
				"value": "Hebrew"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇮🇱",
					"en": "🇮🇱",
					"en-GB": "🇮🇱",
					"en-US": "🇮🇱",
					"es": "🇮🇱",
					"es-419": "🇮🇱",
					"es-ES": "🇮🇱",
					"he": "🇮🇱",
					"it": "🇮🇱",
					"pl": "🇮🇱",
					"sw": "🇮🇱",
					"tl": "🇮🇱",
					"vi": "🇮🇱",
					"zh": "🇮🇱"
				},
				"value": "🇮🇱"
			}
		}
	},
	"Language 13": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "هو - هي",
					"en": "it",
					"en-GB": "it",
					"en-US": "it",
					"es": "él",
					"es-419": "él",
					"es-ES": "él",
					"he": "זֶה",
					"it": "Esso",
					"pl": "To",
					"sw": "hiyo",
					"tl": "ito",
					"vi": "Nó",
					"zh": "它"
				},
				"value": "it"
			},
			"dir": {
				"translations": {
					"ar": "حرف",
					"en": "ltr",
					"en-GB": "ltr",
					"en-US": "ltr",
					"es": "ltr",
					"es-419": "ltr",
					"es-ES": "ltr",
					"he": "ליטר",
					"it": "litri",
					"pl": "ltr",
					"sw": "ltr",
					"tl": "litro",
					"vi": "thư",
					"zh": "升"
				},
				"value": "ltr"
			},
			"label": {
				"translations": {
					"ar": "إيطالي",
					"en": "Italian",
					"en-GB": "Italian",
					"en-US": "Italian",
					"es": "italiano",
					"es-419": "italiano",
					"es-ES": "italiano",
					"he": "אִיטַלְקִית",
					"it": "Italiano",
					"pl": "włoski",
					"sw": "Kiitaliano",
					"tl": "Italyano",
					"vi": "Ý",
					"zh": "意大利语"
				},
				"value": "Italian"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇮🇹",
					"en": "🇮🇹",
					"en-GB": "🇮🇹",
					"en-US": "🇮🇹",
					"es": "🇮🇹",
					"es-419": "🇮🇹",
					"es-ES": "🇮🇹",
					"he": "🇮🇹",
					"it": "🇮🇹",
					"pl": "🇮🇹",
					"sw": "🇮🇹",
					"tl": "🇮🇹",
					"vi": "🇮🇹",
					"zh": "🇮🇹"
				},
				"value": "🇮🇹"
			}
		}
	},
	"Language 14": {
		"permission": "Admin",
		"type": "TextObject",
		"value": {
			"code": {
				"translations": {
					"ar": "pl",
					"en": "pl",
					"en-GB": "pl",
					"en-US": "pl",
					"es": "por favor",
					"es-419": "por favor",
					"es-ES": "por favor",
					"he": "רב",
					"it": "per favore",
					"pl": "proszę",
					"sw": "pl",
					"tl": "pl",
					"vi": "pl",
					"zh": "pl"
				},
				"value": "pl"
			},
			"dir": {
				"translations": {
					"ar": "حرف",
					"en": "ltr",
					"en-GB": "ltr",
					"en-US": "ltr",
					"es": "ltr",
					"es-419": "ltr",
					"es-ES": "ltr",
					"he": "ליטר",
					"it": "litri",
					"pl": "ltr",
					"sw": "ltr",
					"tl": "litro",
					"vi": "thư",
					"zh": "升"
				},
				"value": "ltr"
			},
			"label": {
				"translations": {
					"ar": "بولندي",
					"en": "Polish",
					"en-GB": "Polish",
					"en-US": "Polish",
					"es": "Polaco",
					"es-419": "Polaco",
					"es-ES": "Polaco",
					"he": "פּוֹלָנִית",
					"it": "Polacco",
					"pl": "Polski",
					"sw": "Kipolandi",
					"tl": "Polish",
					"vi": "Đánh bóng",
					"zh": "抛光"
				},
				"value": "Polish"
			},
			"labelFlag": {
				"translations": {
					"ar": "🇵🇱",
					"en": "🇵🇱",
					"en-GB": "🇵🇱",
					"en-US": "🇵🇱",
					"es": "🇵🇱",
					"es-419": "🇵🇱",
					"es-ES": "🇵🇱",
					"he": "🇵🇱",
					"it": "🇵🇱",
					"pl": "🇵🇱",
					"sw": "🇵🇱",
					"tl": "🇵🇱",
					"vi": "🇵🇱",
					"zh": "🇵🇱"
				},
				"value": "🇵🇱"
			}
		}
	},
	"index": 6
}